import { render, staticRenderFns } from "./simple-video-player.vue?vue&type=template&id=a0a77768&scoped=true&"
import script from "./simple-video-player.vue?vue&type=script&lang=js&"
export * from "./simple-video-player.vue?vue&type=script&lang=js&"
import style0 from "./simple-video-player.vue?vue&type=style&index=0&id=a0a77768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a77768",
  null
  
)

export default component.exports